import { notification, message } from 'ant-design-vue'
export function showNotification(message:string, response:any):void {
    notification.open({
        message: message,
        description:response["response"],
        duration: 10
    })
}
export function showNotificationSimple(message:string, description:string, duration?:number):void {
    notification.open({
        message:message,
        description:description,
        duration:duration ? duration : 10
    })
}
export function showSimpleMessage(text:string, type: "success" | "info" | "warning" | "error" | "loading" | undefined):void {
    message.open({
        type: type,
        content: text
    });
}